<app-pan-transaction-type [state]="params.data.action_type"></app-pan-transaction-type>
